<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoadingGrid">
        <div slot="body">
          <div class="col-12 col-md-2">
            <bita-bootbutton
              v-if="!showForm"
              type="primary"
              title="باربری جدید"
              icon="fas fa-plus-square"
              class="w-100"
              @click.native="statusChangeModalCreate"
            />
          </div>
          <hr />
          <bita-grid
            ref="grid"
            :columns="gridColumns"
            :read-data="readData"
            :hasRow="false"
            :resizable="true"
            :schema-total="'total'"
            :schema-data="'data'"
            :server-paging="true"
            :batch="true"
          />
        </div>
      </bita-ibox>
    </div>
    <form-modal
      ref="editModal"
      :isLoading="isLoadingModal"
      :props-data="updateForm"
      :props-state="state"
      :props-city="cities"
      modal-id="edit-modal"
      title="ویرایش باربری"
      @on-submit="handleEdit"
    />
    <form-modal
      ref="createModal"
      :isLoading="isLoadingModal"
      :props-data="createForm"
      :props-state="state"
      modal-id="create-modal"
      title="باربری جدید"
      @on-submit="handleCreate"
    />
    <view-modal
      modal-id="view-modal"
      title="مشخصات باربری"
      :props-data="updateForm"
    />
  </div>
</template>
<script>
import CarriersForm from "./From";
import CarriersView from "./View";

export default {
  components: { "form-modal": CarriersForm, "view-modal": CarriersView },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        {
          title: "مدیریت کاربران",
          link: "/",
        },
        {
          title: "مدیریت باربری ها",
          link: "/management/carriers",
          active: true,
        },
      ],

      isLoadingGrid: false,
      isLoadingModal: false,
      showForm: false,

      createForm: {},
      updateForm: {},
      state: [],
      cities: [],

      gridColumns: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        {
          field: "name",
          title: "نام باربری",
          template: (e) => (e.name ? e.name : " - "),
          width: "100px"
        },
        {
          field: "boss_name",
          title: "نام صاحب باربری",
          template: (e) => (e.boss_name ? e.boss_name : " - "),
           width: "100px"
        },
        {
          field: "carrier_code",
          title: "کد باربری",
          template: (e) => (e.carrier_code ? e.carrier_code : " - "),
           width: "100px"
        },
        {
          field: "phone",
          title: "شماره تماس",
          template: (e) => (e.phone ? e.phone : " - "),
           width: "100px"
        },
        {
          field: "province",
          title: "استان",
          template: (e) =>
            e.city_id && e.city && e.city.province && e.city.province.name
              ? e.city.province.name
              : " - ",
               width: "100px"
        },
        {
          field: "city",
          title: "شهر",
          template: (e) =>
            e.city_id && e.city && e.city.name ? e.city.name : " - ",
             width: "100px"
        },
        {
          field: "postal_code",
          title: "کد پستی",
          template: (e) => (e.postal_code ? e.postal_code : " - "),
           width: "100px"
        },
        {
          field: "address",
          title: "آدرس",
          template: (e) => (e.address ? e.address : " - "),
           width: "100px"
        },
        {
          field: "created_at",
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
             width: "100px"
        },
        {
          title: "عملیات",
          command: [],
           width: "150px"
        },
      ],
    };
  },
  computed: {},
  mounted() {
    Promise.all([this.getState()]).then((res) => {
      this.state = res[0].data;
    });

    this.loadData();
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  methods: {
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", "carriers?include=city")
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.grid.loadDataSource();
    },
    statusChangeModalEdit() {
      this.showModalEdit = !this.showModalEdit;

      $("#edit-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalCreate() {
      $("#create-modal")
        .modal({
          backdrop: "static",
          keyboard: false,
        })
        .modal("toggle");
    },
    statusChangeModalView() {
      this.$toggleModal("#view-modal");
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "edit",
        click: this.edit,
        template: this.gridButtons.edit,
      });
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    edit(e) {
      this.isLoadingModal = true;
      let _this = this;
      let carrier = this.$refs.grid.getSelectedGridRow(e);
      if (carrier.city) this.getCity(carrier.city.parent_id);
      setTimeout(function() {
        _this.updateForm = {
          id: carrier.id ? carrier.id : null,
          boss_name: carrier.boss_name ? carrier.boss_name : null,
          name: carrier.name ? carrier.name : null,
          carrier_code: carrier.carrier_code ? carrier.carrier_code : null,
          phone: carrier.phone ? carrier.phone : null,
          address: carrier.address ? carrier.address : null,
          city_id: carrier.city_id ? carrier.city_id : null,
          postal_code: carrier.postal_code ? carrier.postal_code : null,
          state_id:
            carrier.city_id && carrier.city ? carrier.city.parent_id : null,
        };
        _this.isLoadingModal = false;
      }, 500);
      this.statusChangeModalEdit();
    },
    delete(e) {
      let carrier = this.$refs.grid.getSelectedGridRow(e);

      this.$alert(
        "question",
        `آیا از حذف باربری ${carrier.name} اطمینان دارید ؟`,
        "",
        {
          confirmButtonText: "بله",
        }
      ).then((result) => {
        if (result.value) {
          this.isLoadingGrid = true;
          this.$persistClient("delete", `carriers/${carrier.id}`)
            .then((res) => {
              this.$izitoast("success", "عملیات موفق", res.data.message);
              this.loadData();
            })
            .finally(() => {
              this.isLoadingGrid = false;
            });
        }
      });
    },
    view(e) {
      let carrier = this.$refs.grid.getSelectedGridRow(e);
      this.getCarrier(carrier.id);
      this.statusChangeModalView();
    },
    handleCreate(data) {
      this.isLoadingModal = true;

      this.$persistClient("post", "carriers", data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.messages);

          this.createForm = {};

          this.loadData();
          this.$refs.createModal.reset();

          this.statusChangeModalCreate();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    handleEdit(data) {
      this.isLoadingModal = true;
      this.$persistClient("patch", `carriers/${data.id}`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {};

          this.loadData();
          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    getCarrier(carrier_id) {
      this.isLoadingGrid = true;
      this.$persistClient("get", `carriers/${carrier_id}`)
        .then((res) => {})
        .catch(() => {})
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    getState() {
      return this.$persistClient("get", "cities?filter[province]=0");
    },
    getCity(e) {
      this.$persistClient("get", `cities?filter[province]=${e}`)
        .then((res) => {
          this.cities = res.data;
        })
        .finally((res) => {
          this.isLoadingCities = false;
        });
    },
  },
};
</script>
<style scoped>
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease-in;
}
.fade-leave {
  opacity: 0.2;
}
</style>
